import React, { useState } from "react";
import { Col, Row, Modal } from "antd/es";

import { useInterval } from "../util";
import { fetchResults, fetchStatus } from "../api";


import TrainingRun from "./TrainingRun";
import { useSettings } from "./TrainingOverview";

const TrainingRuns = ({ derive }) => {
    const settings = useSettings()[0];

    const [modal, contextHolder] = Modal.useModal();
    const [recent, setRecent] = useState([]);
    const [currentRuns, setCurrentRuns] = useState([]);

    // Refresh every 5 seconds
    useInterval(() => {
        const { paused, maxResults, combineImages, stepFilter } = settings;

        if (!paused) {
            fetchResults(maxResults * (combineImages ? 8 : 1), { step: stepFilter || undefined }).then(setRecent);
        }
    }, 5000, false, [settings]);

    useInterval(() => {
        fetchStatus().then(setCurrentRuns);
    }, 1000, false, []);

    const images = recent.slice(0, settings.maxResults);

    let groups = {};


    // Associate current runs by their run_id on the rows.
    const statusMap = Object.fromEntries(currentRuns.map(s => ([s.run_id, s])));

    // Turn images into rows, breaking up by run_id
    images.forEach(img => {
        let group = groups[img.run_id];

        if (!img.args.output_dir) {
            img.args.output_dir = "/a/b/c/d"
        }

        if (!group) {
            group = {
                timestamp: statusMap[img.run_id]?.['@timestamp'] || img['@timestamp'],
                run_id: img.run_id,
                args: img.args,
                images: [],
                changes: [],
            };

            groups[img.run_id] = group;
        }

        if (settings.maxImages === 0 || group.images.length < settings.maxImages) {
            group.images.push(img);
        }
    });

    const rows = Object.values(groups).sort((a, b) => b.args.start_time - a.args.start_time);

    // Insert a row if the current run is not included in the most recent runs
    for (const run of currentRuns) {
        if (!run || !run.current_status) {
            continue;
        }

        const currentStatus = run.current_status;

        currentStatus.args.output_dir ??= "/a/b/c/d";
        if (!rows.find(r => r.run_id === run.run_id)) {
            rows.unshift({ run_id: run.run_id, images: [], args: currentStatus.args, changes: [] });
        }
    }

    // Iterate over the rows to find what properties have changed
    // for each experiment.
    for (let i = 1; i < rows.length; ++i) {
        const current = rows[i];
        const next = rows[i - 1];

        new Set([...Object.keys(current.args), ...Object.keys(next.args)]).forEach(k => {
            if (k === 'output_dir' || k === 'abort') {
            } else {
                if (next.args[k] !== current.args[k]) {
                    next.changes.push({
                        param: k,
                        from: current.args[k],
                        to: next.args[k],
                    });
                }
            }
        });
    }

    if (!settings.descending) {
        for (let row of rows) {
            row.images.reverse();
        }
    }

    const runs = rows.map(run => (
        <Col span={24} key={run.run_id}>
            <TrainingRun
                data={run}
                modal={modal}
                status={statusMap[run.run_id]}
                derive={derive}
            />
        </Col>
    ));

    return (
        <Row gutter={[12, 12]} className="training-runs">
            {runs}

            {contextHolder}
        </Row>
    );
};

export default TrainingRuns;